export default "/images/icon_book.svg?c4ff99d295e4ba9e7b94dbe31d84518c";